import Apping from './Components/Fetch';
import './App.css'
function App() {
  return (
    <div className="App">
      {
       <Apping/>
      }
    </div>
  );
}

export default App;
